import { Component, OnInit } from '@angular/core';
import { PageComponent } from 'src/app/shared/components/page.component';
import { Metadata } from 'src/app/shared/models/sys/metadata';

@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.component.html',
  styleUrl: './legal-notice.component.scss',
})
export class LegalNoticeComponent extends PageComponent implements OnInit {
  protected override get metadata(): Metadata {
    return {
      title: 'Mentions légales',
    };
  }

  public ngOnInit(): void {
    this.onMetadata();
  }
}
